module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_forum1.8ad1d.png";